// src/components/Resume.js
import React from 'react';
const Resume = () => {
  return (
    <div>
      <h1>Resume Page</h1>
      <p>This is the resume page content.</p>
    </div>
  );
};

export default Resume;